import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  title: ReactNode;
  subtitle?: string;
  userName?: string;
  onSignOut?: () => void;
}

export function Header({ title, subtitle, userName, onSignOut }: HeaderProps) {
  const navigate = useNavigate();

  return (
    <header className="header">
      <div>
        <h1>{title}</h1>
        {subtitle && <p className="subtitle">{subtitle}</p>}
      </div>
      {userName && (
        <div className="header-session">
          <span className="user-pill">Signed in as {userName}</span>
          <button type="button" className="ghost" onClick={() => navigate("/profile")}>
            Edit profile
          </button>
          <button type="button" className="ghost" onClick={onSignOut}>
            Sign out
          </button>
        </div>
      )}
    </header>
  );
}
